/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import {
  Card,
  Image,
  Navbar,
  Button,
  ButtonGroup,
  Container,
} from 'react-bootstrap';
import { ButtonWithIcon } from '@vlinder-web/button-v2-widget-react';

export interface IAudioPlayerProps {
  audioSrc?: string;
  title?: string;
  closeTitleLabel?: string;
  closeModal?(): void;
}

export const AudioModal = ({
  audioSrc,
  title,
  closeTitleLabel,
  closeModal,
}: IVideoModalProps) => {
  console.log('ajsj', audioSrc);

  if (audioSrc) {
    //@ts-ignore
    return (
      <>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            alignSelf: 'center',
            padding: '5px',
          }}
        >
          <audio width="100%" height="100%" controls id="audio-player">
            <source src={audioSrc} type="audio/mp3" />
          </audio>
        </div>
      </>
    );
  }
  return null;
};

AudioModal.defaultProps = {
  audioSrc: '',
};
